<app-button
    #menuTrigger="appButton"
    [disabled]="!mapFilterPermissionsService.canRead()"
    [icon]="['fas', 'bars-filter']"
    [label]="buttonLabel()"
    [tooltip]="mapFilterPermissionsService.canRead() ? undefined : ('insufficientPermissions' | transloco)"
    [type]="activeFilterCount() ? ButtonType.PRIMARY : ButtonType.SECONDARY"
    (onClick)="mapFilterPermissionsService.canRead() ? toggleMenu() : null" />
